export default __webpack_public_path__ + "static/InterDisplay-BoldItalic-76a4c5c45cf815be4f07b7a3b25a8882.woff2";